/**
 * @flow
 * @relayHash dd048f5101702d2fbe55a4db0a639990
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UserMeQueryVariables = {||};
export type UserMeQueryResponse = {|
  +me: ?any
|};
export type UserMeQuery = {|
  variables: UserMeQueryVariables,
  response: UserMeQueryResponse,
|};
*/


/*
query UserMeQuery {
  me
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "me",
    "args": null,
    "storageKey": null
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "UserMeQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": (v0/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "UserMeQuery",
    "argumentDefinitions": [],
    "selections": (v0/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "UserMeQuery",
    "id": null,
    "text": "query UserMeQuery {\n  me\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '3a5aa218e15b08b4ef6c31116004d2e1';
module.exports = node;
